<form #form fsForm [submit]="save" [dirtySubmitButton]="false" *fsSkeletonForm="environmentCreate">
  <mat-card-content>
    <div class="fs-column" class="full-width">
      <h2>Who would you like to invite to this organization at this time?</h2>
        <div class="fs-row" *ngFor="let item of environmentCreate.members; let index = index">
        <mat-form-field class="full-width">
          <mat-label>Email</mat-label>
          <input
            matInput
            [(ngModel)]="item.email"
            (focus)="focus(index)"
            name="email_{{ item.guid }}"
            fsFormEmail="true">
        </mat-form-field>
      </div>
    </div>
  </mat-card-content>
  <mat-card-actions>
    <button type="submit" mat-raised-button color="primary" class="full-width">Continue</button>
    <button type="button" mat-button class="full-width" (click)="cancel.emit()">Skip</button>
  </mat-card-actions>
</form>
